import React from 'react'
import { Protip } from '@chegg-wt/core/components/ProTip'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { SEARCH_RESULT_LOADING } from './utils/testids'
import * as Styled from './styled'

export const LOADING_HEADING = 'Searching for your source'
export const LOADING_COPY = 'Hang tight! If nothing is happening, please search again.'
export const PRO_TIP_COPY =
  'When rewriting someone else’s words, you’ll still need to cite them'

export default function SearchResultsLoading() {
  return (
    <>
      <Styled.LoadingContainer data-test={SEARCH_RESULT_LOADING}>
        <LoadingDots />
        <Styled.LoadingDescription>
          <Styled.Heading>{LOADING_HEADING}</Styled.Heading>
          <Styled.Body>{LOADING_COPY}</Styled.Body>
        </Styled.LoadingDescription>
        <Protip imgSrc={publicAssetUrl('feather.svg')} protipCopyText={PRO_TIP_COPY} />
      </Styled.LoadingContainer>
    </>
  )
}
